import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  players: [],
  search: '',
  pagination: {
    itemsPerPage: 10,
    currentPage: 1
  },
  filter: 'name',
  loading: true,
  dragging: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/players/index.js